import React, {useState, useEffect} from 'react';
import registeredComponent from "../../utils/registeredComponent";
import apiFetch from "../../utils/apiFetch";
import "./styles/BlackbaudConfigShow.scss";
import FontAwesome from "utils/FA";
import {faExclamationTriangle} from "@fortawesome/pro-solid-svg-icons/faExclamationTriangle";

const BlackbaudConfigShow = () => {
  const [configID, setConfigID] = useState('');

  const [bbLogIn, setBbLogIn]                       = useState('');
  const [existingBbPassword, setExistingBbPassword] = useState('');
  const [bbPassword, setBbPassword]                 = useState('');
  const [siteUrl, setSiteUrl]                       = useState('');
  const [enabled, setEnabled]                       = useState(false);
  const [twoWay, setTwoWay]                         = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    apiFetch.get({}, 'blackbaud_configs')
      .then(json => {
        setConfigID(json.blackbaud_config.id || '');

        setBbLogIn(json.blackbaud_config.bb_log_in || '');
        setExistingBbPassword(json.blackbaud_config.bb_password || '');
        setBbPassword(json.blackbaud_config.bb_password || '');
        setSiteUrl(json.blackbaud_config.site_url || '');
        setEnabled(json.blackbaud_config.enabled || false);
        setTwoWay(json.blackbaud_config.two_way || false);
      });
  }, []);

  const saveBlackbaud = () => {
    apiFetch.put({}, `blackbaud_configs/${configID}`, {
      blackbaud_config: {
        bb_log_in:    bbLogIn,
        bb_password:  bbPassword,
        site_url:     siteUrl,
        enabled:      enabled,
        two_way:      twoWay
      }
    })
      .then(json => {
        Utility.displayFlashMessages({message: json.message});
      })
      .catch(json => {
        Utility.displayFlashMessages({error: json.message});
      });
  };

  const testBlackbaud = () => {
    apiFetch.patch({}, `blackbaud_configs/${configID}`, {
      test: true
    })
      .then(json => {
        Utility.displayFlashMessages({message: json.message});
      })
      .catch(json => {
        Utility.displayFlashMessages({error: json.message});
      });
  };

  return <div className='form-horizontal'>
    <fieldset>
      <legend>Basic Setup</legend>

      {/\w{8}-\w{4}-\w{4}-\w{4}-\w{12}/.test(bbLogIn) === false && <div className={'alert alert-warning'}>
        <FontAwesome icon={faExclamationTriangle} nbsp/>
        Support for using a username and password to log into Blackbaud has been deprecated.
        You will need to enter an API key/secret combination before June 30, 2021.
      </div>}

      <h4 className='blackbaud-config-password-warning'>
        Do not enter your Finalsite Enrollment username/password here!
      </h4>

      <div className='mb-3 row'>
        <label className='col-form-label text-end'>User Name/API Key</label>
        <div className='controls'>
          <input
            defaultValue={bbLogIn}
            name='bbLogIn'
            onChange={(e) => setBbLogIn(e.target.value)}
            type='text'
            className="w-25"
          />
        </div>
      </div>

      <div className='mb-3 row'>
        <label className='col-form-label text-end'>Current Password/API Secret</label>
        <div className='controls'>
          {showPassword && <React.Fragment>
            {existingBbPassword}
            <a onClick={() => setShowPassword(false)} >Hide</a>
          </React.Fragment> || <React.Fragment>
            {'*'.repeat(existingBbPassword.length)}
            <a onClick={() => setShowPassword(true)} >Show</a>
          </React.Fragment>}
        </div>
      </div>

      <div className='mb-3 row'>
        <label className='col-form-label text-end'>New Password/API Secret</label>
        <div className='controls'>
          <input
            autoComplete='new-password'
            name='bbPassword'
            onChange={(e) => setBbPassword(e.target.value)}
            type='text'
            className="w-25"
          />
        </div>
      </div>

      <div className='mb-3 row'>
        <label className='col-form-label text-end'>Site URL</label>
        <div className='controls'>
          <input
            defaultValue={siteUrl}
            name='siteUrl'
            onChange={(e) => setSiteUrl(e.target.value)}
            type='text'
            className="w-25"
          />
        </div>
      </div>

      <div className='mb-3 row'>
        <label className='col-form-label text-end'>Enable Blackbaud Integration</label>
        <div className='controls'>
          <input
            checked={enabled}
            name='enabled'
            onChange={(e) => setEnabled(!enabled)}
            type='checkbox'
          />
        </div>
      </div>

      <div className='mb-3 row'>
        <label className='col-form-label text-end'>Enable Two Way Integration</label>
        <div className='controls'>
          <input
            checked={twoWay}
            name='two_way'
            onChange={(e) => setTwoWay(!twoWay)}
            type='checkbox'
          />
        </div>
      </div>

      <div className='mb-3 row'>
        <div className='controls offset-md-2'>
          <div className='helper-text'>
            Note: You MUST save your credentials before you test them
          </div>

          <button className='btn btn-primary' onClick={saveBlackbaud} style={{marginRight: '1rem'}}>Save</button>
          <button className='btn btn-success' onClick={testBlackbaud}>Test</button>
        </div>
      </div>
    </fieldset>
  </div>;
}

export default registeredComponent('BlackbaudConfigShow')(BlackbaudConfigShow);
